import { render, staticRenderFns } from "./UserGymBookingList.vue?vue&type=template&id=13b58b8e"
import script from "./UserGymBookingList.vue?vue&type=script&lang=js"
export * from "./UserGymBookingList.vue?vue&type=script&lang=js"
import style0 from "./UserGymBookingList.vue?vue&type=style&index=0&id=13b58b8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports